import React, { useState, useEffect } from 'react';
import AddEditCardForm from '../add-edit-card-form/add-edit-card-form';
import { DataTable, TableColumn } from '@ampol/design-system';
import { sortBy } from 'utilities/core-utilities';
import './edit-multiple-card.scss';

/**
 * Describe component here
 * @param props
 */
const EditMultipleCard = ({
  onClose,
  cardDetail,
  cardDetailLoading = false,
  isConfirmScreen = false,
  cardList,
  onCardChanges,
  setIsFormValid,
  setModifiedCardDetails,
}) => {
  return (
    <div className={'edit-multiple-card'}>
      {cardDetailLoading && <div>Loading...</div>}
      {!cardDetailLoading &&
        cardDetail &&
        Object.keys(cardDetail).length > 0 &&
        !isConfirmScreen && (
        <div>
          {' '}
          <AddEditCardForm
            onClose={onClose}
            cardDetails={
              cardDetail ? Object.assign({}, cardDetail) : undefined
            }
            onCardChanges={onCardChanges}
            isEditMultipleCard
            formId={`edit-multiple-card-${cardDetail?.cardNumber}`}
            setIsFormValid={setIsFormValid}
            setModifiedCardDetails={setModifiedCardDetails}
          />
        </div>
      )}
      {isConfirmScreen && <EditConfirmChanges cardList={cardList} />}
    </div>
  );
};

export default EditMultipleCard;

interface Card {
  contractNumber: string;
  contractIdentifier: string;
  driverName: string;
}

interface EditConfirmChangesProps {
  cardList: Card[];
}

export const EditConfirmChanges: React.FC<EditConfirmChangesProps> = ({
  cardList,
}) => {
  const [list, setList] = useState<Card[]>(cardList);

  useEffect(() => {
    if (cardList) setList(cardList);
  }, [cardList]);

  const getColumns = (): TableColumn[] => {
    return [
      {
        header: 'Account',
        accessorKey: 'contractNumber',
        id: 'contractNumber',
        defaultSorted: 'desc',
      },
      {
        header: 'Card',
        accessorKey: 'contractIdentifier',
        id: 'contractIdentifier',
      },
      {
        header: 'Driver Name',
        accessorKey: 'driverName',
        id: 'driverName',
      },
    ];
  };

  const sortData = (name: keyof Card, isAsc: boolean) => {
    const sortedData = sortBy(list, name, isAsc); // Ensure sortBy is properly typed
    setList(sortedData);
  };

  return (
    <div>
      <DataTable
        caption="Edit Multiple Card list"
        columns={getColumns()}
        data={list}
        isLoading={false}
        tableVariant="list"
        onColumnSorted={sortData}
        noDataMessage="No card details were updated. Submitting will update status."
      />
    </div>
  );
};
